import { StackingInfoTile } from './StackingInfoTile';

export default StackingInfoTile;
